<template>
  <settings-modal
    class="payment-channel-change-modal t-channel-change-modal"
  >
    <template slot="heading">Change channel</template>
    <template>
      <v-select
        v-model="form.channel"
        class="t-channel-select"
        :items="allowedChannelOptions"
        item-text="name"
        item-value="value"
        label="Select channel"
        :error-messages="getValidationErrorMessage('channel')"
      />
      <error-alert :error="error" />
    </template>

    <template slot="actions">
      <v-btn
        class="t-confirm-channel"
        color="primary"
        medium
        flat
        :disabled="isConfirmButtonDisabled"
        @click="onConfirmButtonClick"
      >confirm</v-btn>

      <v-btn
        class="t-close-modal"
        color="primary"
        medium
        flat
        @click="onCancelButtonClick"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import PaymentApi from '@/services/Api/PaymentApi'

  // Events
  import { EVENT_PAYMENT_UPDATE } from '@/events/payments'

  // Mixins
  import form from '@/mixins/form'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'PaymentChannelChangeModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    mixins: [form],
    data () {
      return {
        form: { channel: null },
        requiredFields: ['channel'],
        changeChannelApiRequest: new ApiRequest(PaymentApi.changeChannelBySupervisor)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      paymentId () {
        return this.modal.data.paymentId
      },
      currentChannel () {
        return this.modal.data.channel
      },
      allowedChannelOptions () {
        return this.modal.data.allowedChannelOptions
      },
      error () {
        return this.changeChannelApiRequest.error
      },
      isConfirmButtonDisabled () {
        return this.changeChannelApiRequest.loading || !this.isFormFilled || this.form.channel === this.currentChannel
      }
    },
    created () {
      this.setFieldValue('channel', this.currentChannel)
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        this.changeChannel(this.form.channel)
          .then(() => {
            this.$eventHub.$emit(EVENT_PAYMENT_UPDATE)

            this.showModal({
              name: 'SuccessFlashModal',
              data: {
                message: 'Payment channel has been successfully updated'
              }
            })
          })
          .catch(() => {})
      },
      onCancelButtonClick () {
        this.closeModal()
      },
      changeChannel (channel) {
        return this.changeChannelApiRequest.execute(this.paymentId, channel)
      }
    }
  }
</script>
